/**
 * ═══════════════════════════════════════════════════════════════
 *  空间图标库 —— 自动生成，别手改
 * ═══════════════════════════════════════════════════════════════
 *
 * 图标来自 **Remix Icon**（https://remixicon.com，Apache License 2.0），
 * 国内后台系统最常见的那套画风。
 *
 * 🔴 **SVG 数据直接进仓库，不引任何外部图标脚本。**
 *    引外链的话：图标源站挂了首页就缺一块、每次打开多一个跨域请求、
 *    而且那家的图标编号变了我们这边会静默画错东西。图标是页面骨架的一部分，
 *    不该依赖别人的服务器。
 *
 * ⚠️ 要增删图标：改 `scripts/gen-space-icons.mjs` 里的清单再跑一次
 *    `node scripts/gen-space-icons.mjs`。
 * ⚠️ `key` 会存进后台配置里，**改名等于让老板配好的图标失效**，只增不改。
 */

export interface SpaceIconDef {
  key: string;
  label: string;
  group: string;
  /**
   * 同一个图标的 emoji 画法。后台可以整排切过去。
   * ⚠️ emoji 自带颜色且字形由系统字体决定，跟不了配色 ——
   *    这是它本来的样子，不是 bug。
   */
  emoji: string;
  /** viewBox 统一是 0 0 24 24，填充色用 currentColor。 */
  d: string[];
}

export const SPACE_ICONS: SpaceIconDef[] = [
  {
    key: "sofa",
    label: "客厅 · 沙发",
    group: "空间",
    emoji: "🛋️",
    d: [
      "M9 3a6 6 0 0 0-6 6v.351c-1.52.746-2.367 2.565-1.733 4.307l.312.86a7 7 0 0 1 .422 2.391V19.5A1.5 1.5 0 0 0 3.5 21h17a1.5 1.5 0 0 0 1.5-1.5v-2.59a7 7 0 0 1 .421-2.393l.313-.86c.633-1.741-.213-3.56-1.734-4.306V9a6 6 0 0 0-6-6zm10 6.032c-1.694.23-3 1.682-3 3.44V14H8v-1.528a3.47 3.47 0 0 0-3-3.44V9a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4zM16 16v1h2v-4.528a1.472 1.472 0 1 1 2.855.502l-.312.86A9 9 0 0 0 20 16.909V19H4v-2.09a9 9 0 0 0-.542-3.076l-.313-.86A1.471 1.471 0 1 1 6 12.472V17h2v-1z",
    ],
  },
  {
    key: "bed",
    label: "卧室 · 床",
    group: "空间",
    emoji: "🛏️",
    d: [
      "M22 11v9h-2v-3H4v3H2V4h2v10h8V7h6a4 4 0 0 1 4 4m-2 3v-3a2 2 0 0 0-2-2h-4v5zM8 11a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 2a3 3 0 1 1 0-6a3 3 0 0 1 0 6",
    ],
  },
  {
    key: "kitchen",
    label: "厨房 · 灶具",
    group: "空间",
    emoji: "🍳",
    d: [
      "M21 2v20h-2v-7h-4V8a6 6 0 0 1 6-6m-2 2.53C18.17 5 17 6.17 17 8v5h2zM9 13.9V22H7v-8.1A5 5 0 0 1 3 9V3h2v7h2V3h2v7h2V3h2v6a5 5 0 0 1-4 4.9",
    ],
  },
  {
    key: "shower",
    label: "卫浴 · 花洒",
    group: "空间",
    emoji: "🚿",
    d: [
      "M5 16.93a8 8 0 1 1 11.458-9.831A5.5 5.5 0 0 1 19 17.793v-2.13a3.5 3.5 0 1 0-4-5.612V10a6 6 0 1 0-10 4.472zM7 16h2v4H7zm8 0h2v4h-2zm-4 3h2v4h-2z",
    ],
  },
  {
    key: "balcony",
    label: "阳台 · 绿植",
    group: "空间",
    emoji: "🪴",
    d: [
      "M5.998 2a7 7 0 0 1 6.197 3.741A6.49 6.49 0 0 1 17.498 3h3.5v2.5a6.5 6.5 0 0 1-6.5 6.5h-1.5v1h5v7a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-7h5v-2h-2a7 7 0 0 1-7-7V2zm10 13h-8v5h8zm3-10h-1.5a4.5 4.5 0 0 0-4.5 4.5v.5h1.5a4.5 4.5 0 0 0 4.5-4.5zm-13-1h-2a5 5 0 0 0 5 5h2a5 5 0 0 0-5-5",
    ],
  },
  {
    key: "dining",
    label: "餐厅 · 餐具",
    group: "空间",
    emoji: "🍽️",
    d: [
      "M16 13V5H6v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2M5 3h15a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V4a1 1 0 0 1 1-1m13 2v3h2V5zM2 19h18v2H2z",
    ],
  },
  {
    key: "study",
    label: "书房 · 书",
    group: "空间",
    emoji: "📚",
    d: [
      "M13 21v2h-2v-2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a4 4 0 0 1 3 1.354A4 4 0 0 1 15 3h6a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1zm7-2V5h-5a2 2 0 0 0-2 2v12zm-9 0V7a2 2 0 0 0-2-2H4v14z",
    ],
  },
  {
    key: "kids",
    label: "儿童房",
    group: "空间",
    emoji: "🧸",
    d: [
      "M12 17a4 4 0 0 0 4-4h-2a2 2 0 1 1-4 0H8a4 4 0 0 0 4 4M6.5 2a4.5 4.5 0 0 0-2.95 7.898a9 9 0 1 0 16.901 0a4.5 4.5 0 1 0-6.79-5.745a9 9 0 0 0-3.321 0A4.5 4.5 0 0 0 6.5 2M4 6.5a2.5 2.5 0 0 1 4.852-.851l.318.878l.898-.257A7 7 0 0 1 12 6c.672 0 1.32.094 1.932.27l.898.257l.318-.878a2.501 2.501 0 1 1 3.58 3.03l-.814.46l.404.842a7 7 0 1 1-12.635 0l.403-.843l-.814-.46A2.5 2.5 0 0 1 4 6.5",
    ],
  },
  {
    key: "wardrobe",
    label: "衣帽间 · 衣物",
    group: "空间",
    emoji: "👕",
    d: [
      "m14.514 5l2.606-2.607a1 1 0 0 1 1.414 0l4.243 4.243a1 1 0 0 1 0 1.414l-3.778 3.778V21a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1v-9.17L1.22 8.05a1 1 0 0 1 0-1.414l4.242-4.243a1 1 0 0 1 1.414 0L9.484 5zm.828 2H8.656L6.17 4.515L3.342 7.343L6.999 11v9h10v-9l3.657-3.657l-2.829-2.828z",
    ],
  },
  {
    key: "entry",
    label: "玄关 · 门",
    group: "空间",
    emoji: "🚪",
    d: [
      "M17.998 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2h-10v14h10zm-2 6v2h-2v-2z",
    ],
  },
  {
    key: "garage",
    label: "车库 · 车",
    group: "空间",
    emoji: "🚗",
    d: [
      "M19 20H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V11l2.48-5.788A2 2 0 0 1 6.32 4h11.36a2 2 0 0 1 1.838 1.212L22 11v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm1-7H4v5h16zM4.176 11h15.648l-2.143-5H6.32zM6.5 17a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m11 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3",
    ],
  },
  {
    key: "storage",
    label: "储藏间",
    group: "空间",
    emoji: "📦",
    d: [
      "M3 10H2V4.003C2 3.449 2.455 3 2.992 3h18.016A.99.99 0 0 1 22 4.003V10h-1v10.002a.996.996 0 0 1-.993.998H3.993A.996.996 0 0 1 3 20.002zm16 0H5v9h14zM4 5v3h16V5zm5 7h6v2H9z",
    ],
  },
  {
    key: "wholehouse",
    label: "全屋 · 整装",
    group: "空间",
    emoji: "🏠",
    d: [
      "M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1m-6-2h5V9.157l-6-5.454l-6 5.454V19h5v-6h2z",
    ],
  },
  {
    key: "outdoor",
    label: "庭院 · 景观",
    group: "空间",
    emoji: "🏞️",
    d: [
      "M11.27 12.216L15 6l8 15H2L9 8zm1.12 2.022L14.987 19h4.68l-4.77-8.942zM5.348 19h7.304L9 12.219zM5.5 8a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5",
    ],
  },
  {
    key: "tile",
    label: "瓷砖",
    group: "建材",
    emoji: "🧱",
    d: [
      "M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM11 13H4v6h7zm9 0h-7v6h7zm-9-8H4v6h7zm9 0h-7v6h7z",
    ],
  },
  {
    key: "floor",
    label: "地板 · 层叠",
    group: "建材",
    emoji: "🪵",
    d: [
      "m20.083 15.2l1.202.721a.5.5 0 0 1 0 .858l-8.77 5.262a1 1 0 0 1-1.03 0l-8.77-5.262a.5.5 0 0 1 0-.858l1.202-.721L12 20.05zm0-4.7l1.202.721a.5.5 0 0 1 0 .858L12 17.649l-9.285-5.57a.5.5 0 0 1 0-.858l1.202-.721L12 15.35zm-7.569-9.191l8.771 5.262a.5.5 0 0 1 0 .858L12 12.999L2.715 7.43a.5.5 0 0 1 0-.858l8.77-5.262a1 1 0 0 1 1.03 0M12 3.332L5.887 7L12 10.668L18.113 7z",
    ],
  },
  {
    key: "lamp",
    label: "灯具",
    group: "建材",
    emoji: "💡",
    d: [
      "M9.973 18H11v-5h2v5h1.027c.132-1.202.745-2.193 1.74-3.277c.113-.122.832-.867.917-.973a6 6 0 1 0-9.37-.002c.086.107.807.853.918.974c.996 1.084 1.609 2.076 1.741 3.278M10 20v1h4v-1zm-4.246-5a8 8 0 1 1 12.49.002C17.624 15.774 16 17 16 18.5V21a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2.5C8 17 6.375 15.774 5.754 15",
    ],
  },
  {
    key: "window",
    label: "门窗",
    group: "建材",
    emoji: "🪟",
    d: [
      "M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 8H4v8h16zm0-6H4v4h16zm-9 1v2H9V6zM7 6v2H5V6z",
    ],
  },
  {
    key: "lock",
    label: "门锁 · 安防",
    group: "建材",
    emoji: "🔒",
    d: [
      "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-1-7.208a2.5 2.5 0 1 1 2 0V16h-2z",
    ],
  },
  {
    key: "paint",
    label: "涂料 · 刷子",
    group: "建材",
    emoji: "🖌️",
    d: [
      "M5 4.997v3h14v-3zm-1-2h16a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1m2 9h6a1 1 0 0 1 1 1v3h1v6h-4v-6h1v-2H5a1 1 0 0 1-1-1v-2h2zm11.732 1.732L19.5 11.96l1.768 1.768a2.5 2.5 0 1 1-3.536 0",
    ],
  },
  {
    key: "brush",
    label: "油漆 · 滚筒",
    group: "建材",
    emoji: "🪣",
    d: [
      "m15.457 9.675l-.143-.142a5.5 5.5 0 0 0-2.39-1.349c-2.907-.779-5.699.869-6.492 3.83c-.043.16-.066.34-.104.791c-.154 1.87-.594 3.265-1.8 4.68c2.26.888 4.938 1.514 6.974 1.514a5.505 5.505 0 0 0 5.31-4.079a5.5 5.5 0 0 0-1.356-5.245m-2.168-3.462l4.939-3.842a1 1 0 0 1 1.32.083l2.995 2.994a1 1 0 0 1 .082 1.32l-3.84 4.939a7.505 7.505 0 0 1-7.283 9.292C8 20.999 3.5 19.497 1 17.997c3.98-3 3.047-4.81 3.5-6.5c1.058-3.95 4.842-6.258 8.789-5.284M16.7 8.092q.098.095.194.193L18.03 9.42l2.475-3.182l-1.746-1.746l-3.182 2.475z",
    ],
  },
  {
    key: "tools",
    label: "五金 · 工具",
    group: "建材",
    emoji: "🔧",
    d: [
      "M5.33 3.272a3.5 3.5 0 0 1 4.254 4.962l10.709 10.71l-1.414 1.414l-10.71-10.71a3.502 3.502 0 0 1-4.962-4.255L5.444 7.63a1.5 1.5 0 0 0 2.121-2.121zm10.367 1.883l3.182-1.768l1.414 1.415l-1.768 3.182l-1.768.353l-2.12 2.121l-1.415-1.414l2.121-2.121zm-6.718 8.132l1.415 1.414l-5.304 5.303a1 1 0 0 1-1.492-1.327l.078-.087z",
    ],
  },
  {
    key: "hammer",
    label: "施工 · 锤子",
    group: "建材",
    emoji: "🔨",
    d: [
      "M20 2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5v13a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V9H3.5a1 1 0 0 1-1-1V5.618a1 1 0 0 1 .553-.894L8.5 2zm-5 2H8.972L4.5 6.236V7H11v14h2V7h2zm4 0h-2v3h2z",
    ],
  },
  {
    key: "ruler",
    label: "定制 · 量尺",
    group: "建材",
    emoji: "📐",
    d: [
      "M17 19h2v-5h-9V5H5v2h2v2H5v2h3v2H5v2h2v2H5v2h2v-2h2v2h2v-3h2v3h2v-2h2zm-5-7h8a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1z",
    ],
  },
  {
    key: "waterproof",
    label: "防水",
    group: "建材",
    emoji: "💧",
    d: [
      "m12 3.097l-4.95 4.95a7 7 0 1 0 9.9 0zM12 .27l6.364 6.364a9 9 0 1 1-12.728 0z",
    ],
  },
  {
    key: "purifier",
    label: "净水",
    group: "建材",
    emoji: "🚰",
    d: [
      "m12.005 3.103l-4.95 4.95a7 7 0 1 0 9.9 0zm0-2.828l6.364 6.364A9 9 0 1 1 5.64 19.367a9 9 0 0 1 0-12.728zm1 10.728h2.5l-4.5 6.5v-4.5h-2.5l4.5-6.5z",
    ],
  },
  {
    key: "heating",
    label: "采暖",
    group: "建材",
    emoji: "🔥",
    d: [
      "M12 23a7.5 7.5 0 0 0 7.5-7.5c0-.866-.23-1.697-.5-2.47q-2.5 2.47-3.8 2.47c3.995-7 1.8-10-4.2-14c.5 5-2.796 7.274-4.138 8.537A7.5 7.5 0 0 0 12 23m.71-17.765c3.241 2.75 3.257 4.887.753 9.274c-.761 1.333.202 2.991 1.737 2.991c.688 0 1.384-.2 2.119-.595a5.5 5.5 0 1 1-9.087-5.412c.126-.118.765-.685.793-.71c.424-.38.773-.717 1.118-1.086c1.23-1.318 2.114-2.78 2.566-4.462",
    ],
  },
  {
    key: "cooling",
    label: "制冷",
    group: "建材",
    emoji: "❄️",
    d: [
      "m12 3.298l2.446-1.63l1.11 1.664L13 5.035v5.233l4.531-2.617l.198-3.064l1.996.13l-.19 2.932l2.635 1.303l-.886 1.792l-2.753-1.36L14.001 12l4.532 2.616l2.752-1.36l.886 1.792l-2.634 1.303l.19 2.932l-1.997.129l-.197-3.064L13 13.732v5.233l2.554 1.703l-1.109 1.664L12 20.702l-2.446 1.63l-1.109-1.664L11 18.965v-5.233l-4.532 2.616l-.198 3.064l-1.996-.128l.19-2.933l-2.635-1.303l.887-1.793l2.752 1.361L10 12L5.469 9.383l-2.752 1.361l-.887-1.793L4.465 7.65l-.19-2.933l1.997-.129l.197 3.064l4.532 2.616V5.035L8.446 3.332l1.11-1.664z",
    ],
  },
  {
    key: "electric",
    label: "水电 · 插座",
    group: "建材",
    emoji: "🔌",
    d: [
      "M13 18v2h6v2h-6a2 2 0 0 1-2-2v-2H8a4 4 0 0 1-4-4V7a1 1 0 0 1 1-1h3V2h2v4h4V2h2v4h3a1 1 0 0 1 1 1v7a4 4 0 0 1-4 4zm-5-2h8a2 2 0 0 0 2-2v-3H6v3a2 2 0 0 0 2 2m10-8H6v1h12zm-6 6.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2",
    ],
  },
  {
    key: "appliance",
    label: "家电 · 冰箱",
    group: "建材",
    emoji: "🧊",
    d: [
      "M18.998 1a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm-1 11h-12v9h12zm-8 2v4h-2v-4zm8-11h-12v7h12zm-8 2v3h-2V5z",
    ],
  },
  {
    key: "av",
    label: "影音 · 电视",
    group: "建材",
    emoji: "📺",
    d: [
      "M15.414 5h5.594c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 20V6c0-.552.455-1 .992-1h5.594L6.05 2.464L7.464 1.05L11.414 5h1.172l3.95-3.95l1.414 1.414zM4 7v12h16V7z",
    ],
  },
  {
    key: "soft",
    label: "软装 · 配色",
    group: "建材",
    emoji: "🎨",
    d: [
      "M12 2c5.522 0 10 3.978 10 8.889a5.56 5.56 0 0 1-5.556 5.555h-1.966c-.922 0-1.667.745-1.667 1.667c0 .422.167.811.422 1.1c.267.3.434.689.434 1.122C13.667 21.256 12.9 22 12 22C6.478 22 2 17.522 2 12S6.478 2 12 2m-1.189 16.111a3.664 3.664 0 0 1 3.667-3.667h1.966A3.56 3.56 0 0 0 20 10.89C20 7.139 16.468 4 12 4a8 8 0 0 0-.676 15.972a3.65 3.65 0 0 1-.513-1.86M7.5 12a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3M12 9a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3",
    ],
  },
  {
    key: "greenery",
    label: "绿植",
    group: "建材",
    emoji: "🌿",
    d: [
      "M20.998 3v2c0 9.627-5.373 14-12 14H5.241a17 17 0 0 0-.243 3h-2c0-1.363.116-2.6.346-3.732Q2.999 16.327 2.998 13c0-5.523 4.477-10 10-10c2 0 4 1 8 0m-8 2a8 8 0 0 0-8 8q0 .543.01 1.046c1.254-1.978 3.091-3.541 5.494-4.914l.992 1.736C8.64 12.5 6.746 14.354 5.774 17h3.224c6.015 0 9.871-3.973 9.997-11.612c-1.372.133-2.647.048-4.22-.188c-1.15-.173-1.376-.2-1.777-.2",
    ],
  },
  {
    key: "daylight",
    label: "采光",
    group: "建材",
    emoji: "☀️",
    d: [
      "M12 18a6 6 0 1 1 0-12a6 6 0 0 1 0 12m0-2a4 4 0 1 0 0-8a4 4 0 0 0 0 8M11 1h2v3h-2zm0 19h2v3h-2zM3.515 4.929l1.414-1.414L7.05 5.636L5.636 7.05zM16.95 18.364l1.414-1.414l2.121 2.121l-1.414 1.414zm2.121-14.85l1.414 1.415l-2.121 2.121l-1.414-1.414zM5.636 16.95l1.414 1.414l-2.121 2.121l-1.414-1.414zM23 11v2h-3v-2zM4 11v2H1v-2z",
    ],
  },
  {
    key: "safe",
    label: "安防 · 保险箱",
    group: "建材",
    emoji: "🔐",
    d: [
      "M20.005 20.333V22h-2v-1.334l-7.418 1.237a.5.5 0 0 1-.582-.493V20h-4v2h-2v-2h-1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7V1.59a.5.5 0 0 1 .582-.493L21.17 2.86a1 1 0 0 1 .836.986V6h1v2h-1v7h1v2h-1v2.153a1 1 0 0 1-.836.986zM4.005 5v13h6V5zm8 14.639l8-1.334V4.694l-8-1.333zm4.5-5.64c-.828 0-1.5-1.119-1.5-2.5c0-1.38.672-2.5 1.5-2.5s1.5 1.12 1.5 2.5c0 1.381-.672 2.5-1.5 2.5",
    ],
  },
  {
    key: "store",
    label: "门店",
    group: "建材",
    emoji: "🏪",
    d: [
      "M21 13.242V20h1v2H2v-2h1v-6.758A4.5 4.5 0 0 1 1 9.5c0-.827.224-1.624.633-2.303L4.345 2.5a1 1 0 0 1 .866-.5H18.79a1 1 0 0 1 .866.5l2.703 4.682c.418.694.642 1.49.642 2.318c0 1.56-.794 2.935-2 3.742m-2 .73a4.5 4.5 0 0 1-3.75-1.36A4.5 4.5 0 0 1 12 14.001a4.5 4.5 0 0 1-3.25-1.387A4.5 4.5 0 0 1 5 13.973V20h14zM5.789 4L3.356 8.213a2.5 2.5 0 1 0 4.466 2.216c.335-.837 1.52-.837 1.856 0a2.5 2.5 0 0 0 4.644 0c.335-.837 1.52-.837 1.856 0a2.5 2.5 0 1 0 4.457-2.232L18.21 4z",
    ],
  },
];
